<div class="flex flex-col flex-auto items-center sm:justify-center min-w-0 max-h-[84vh] overflow-y-auto">
  <div class="w-full pb-8 px-4 sm:rounded-2xl sm:bg-card overflow-y-auto max-h-[830px] flex justify-center">
    <button mat-icon-button (click)="cancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
    <div class="w-full max-w-80 sm:w-80 mx-auto sm:mx-0">
      <div class="mt-8 text-3xl font-extrabold tracking-tight leading-tight">
        {{ data.title }}
      </div>
      <div class="mt-8 text-lg">
        <p>{{ data.message }}</p>
      </div>
      <div class="mt-8 flex justify-end">
        <button
          class="fuse-mat-button-large w-full mt-6 mr-1.5 shadow-[2px_3px_15px_-3px_rgba(0,0,0,0.2)]"
          mat-button
          (click)="cancel()"
        >
          Cancel
        </button>
        <button
          class="fuse-mat-button-large w-full mt-6"
          mat-flat-button
          [color]="'primary'"
          [disabled]="remaining > 0"
          (click)="confirm()"
          cdkFocusInitial
        >
          {{ data.confirmButtonText }}
          @if (remaining > 0) {
            ({{ remaining }})
          }
        </button>
      </div>
    </div>
  </div>
</div>
